export default "__VITE_ASSET__BhKq0_Iv__"